// extracted by mini-css-extract-plugin
module.exports = {"logOutDiv":"Logout_logOutDiv__q2tGI","logOutTxt":"Logout_logOutTxt__3PB9h"};